module.exports = __webpack_public_path__ + "static/unicorn2-682d0b0fd94a72c4e9b9a4bd1a3e5696.png";